"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var environment_1 = require("@shared/types/environment");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var WidgetTag;
(function (WidgetTag) {
    WidgetTag["TABLE"] = "TABLE";
    WidgetTag["TEXT"] = "TEXT";
    WidgetTag["RSDK"] = "REPORTING SDK";
})(WidgetTag || (WidgetTag = {}));
(function (module) {
    module.factory('prCustomWidgetService', [
        'rsEnvironment',
        function (env) {
            /**
             * @type {object} customWidgets - map from widget name to widget info from prs
             * 	@property {Array.<string>} customWidgets[widgetName].dependencies - dependencies for the widget (if any)
             * 	@property {string} customWidgetsWidgets[widgetName].dataComponent - data component for widget (if any)
             */
            var customWidgets = env.get(environment_1.ENV_VARS.CUSTOM_WIDGETS);
            var tableWidgets = populateWidgetsWithTag(WidgetTag.TABLE);
            var textWidgets = populateWidgetsWithTag(WidgetTag.TEXT);
            var customRsdkWidgets = populateWidgetsWithTag(WidgetTag.RSDK);
            var nonResizableWidgets = populateNonResizableWidgets();
            function getCustomWidgets() {
                return customWidgets;
            }
            function getTableWidgets() {
                return tableWidgets;
            }
            function getTextWidgets() {
                return textWidgets;
            }
            function getNonResizableWidgets() {
                return nonResizableWidgets;
            }
            function getCustomRsdkWidgets() {
                return customRsdkWidgets;
            }
            function populateNonResizableWidgets() {
                // @ts-ignore
                var widgets = [];
                lodash_1.default.forEach(customWidgets, function (widgetInfo, widgetName) {
                    var resize = lodash_1.default.get(widgetInfo, 'registryMeta.resize', []);
                    if (lodash_1.default.toUpper(resize) === 'NONE') {
                        widgets.push(widgetName);
                    }
                });
                // @ts-ignore
                return widgets;
            }
            function populateWidgetsWithTag(tag) {
                // @ts-ignore
                var widgets = [];
                lodash_1.default.forEach(customWidgets, function (widgetInfo, widgetName) {
                    var tags = lodash_1.default.get(widgetInfo, 'registryMeta.tags', []);
                    if (lodash_1.default.includes(tags.map(lodash_1.default.upperCase), tag)) {
                        widgets.push(widgetName);
                    }
                });
                // @ts-ignore
                return widgets;
            }
            function getDefaultWidgetTitle(type) {
                if (customWidgets) {
                    var customWidget = lodash_1.default.get(customWidgets, type);
                    if (customWidget && lodash_1.default.has(customWidget, 'registryMeta.defaultTitle')) {
                        return customWidget.registryMeta.defaultTitle;
                    }
                }
            }
            function getDefaultWidgetStyle(type) {
                if (customWidgets) {
                    var customWidget = lodash_1.default.get(customWidgets, type);
                    if (customWidget && lodash_1.default.has(customWidget, 'registryMeta.defaultStyle')) {
                        return customWidget.registryMeta.defaultStyle;
                    }
                }
                return {};
            }
            return {
                getCustomWidgets: getCustomWidgets,
                getNonResizableWidgets: getNonResizableWidgets,
                getTableWidgets: getTableWidgets,
                getTextWidgets: getTextWidgets,
                getCustomRsdkWidgets: getCustomRsdkWidgets,
                getDefaultWidgetTitle: getDefaultWidgetTitle,
                getDefaultWidgetStyle: getDefaultWidgetStyle
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
